var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoOff = function SvgVideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.535 39.358l-4.124-3.187c1.154-.105 2.19-1.028 2.19-2.333V14.563c0-1.912-2.183-3.03-3.78-1.935l-8.22 5.67v10.29l-2.4-1.852v-13.35c0-1.98-1.605-3.585-3.585-3.585H9.293l-5.88-4.545c-.525-.405-1.275-.315-1.688.21l-1.47 1.89c-.405.525-.315 1.275.21 1.68l2.738 2.115 27.998 21.645 13.387 10.35c.525.405 1.275.315 1.688-.21l1.47-1.898c.412-.517.314-1.275-.21-1.68zM2.4 35.016c0 1.98 1.605 3.585 3.585 3.585h21.63c.84 0 1.606-.3 2.22-.788L2.4 16.603v18.413z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0z"
  })))));
};
export default SvgVideoOff;